import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css'; 
import logo from './assets/airplane.png'; 
import airplane from './assets/airplane.png';
import background from './assets/background-dark.png'; 
import radial from './assets/radial.jpg'; 

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [id, setId] = useState('');
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();

    if (email !== null && password !== null) {
      onLogin();
      navigate('/home');
    } else {
      alert("Invalid credentials. Please try again.");
    }
  };

  return (
    <div className="login-container" style={{ backgroundImage: `url(${background})` }}>
      <div className="radial-background" style={{ backgroundImage: `url(${radial})` }}>
        <img src={airplane} alt="Airplane" className="airplane-logo" />
      </div>
      <div className="content">
        <img src={logo} alt="Predict Aviator Logo" className="logo" />
        <div className="welcome">Welcome to</div>
        <h1>Predict Aviator</h1>
        <form className="login-form" onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="ID 1XBET/MELBET/MOSTBET"
            value={id}
            onChange={(e) => setId(e.target.value)}
          />
          <button type="submit" className="login-btn">Login</button>
        </form>
        <span className="signup-btn"><a href="#">Sign up</a></span>
      </div>
    </div>
  );
};

export default Login;
